import React from 'react';
import {Route, Routes} from 'react-router-dom';
import Login from '@pages/Login';
import ProtectedRoute from './ProtectedRoute';
import LandContainer from '@container/LandContainer';
import UserContainer from '@container/UserContainer';
import {MainContainer} from '@container/MainContainer';
import DetailParcelle from '@component/detailparcelle/DetailParcelleComponent';
import {Landing} from '@pages/Landing';
import ListCrm from '@component/listcrm/listcrm';
import DetailCrm from '../component/detailcrm/detailcrm';
import {ContactProvider} from '../Context/crm/ContactContext';
import MyLandContainer from "../container/MyLandContainer";
import MapsContainer from '../container/MapContainer';
import MyLandMapsContainer from '../container/MyLandMapContainer';
import LandsMapByMapBox from "../component/maps/LandsMapByMapBox";
import {TagContainer} from "../container/TagContainer";
import TransactionContainer from '../container/TransactionContainer';
import FaosContainer from '../container/FaosContainer';
import {InscriptionChoice} from "../pages/inscription/InscriptionChoice";
import {InscriptionParticulier} from "../pages/inscription/InscriptionParticulier";
import {InscriptionContainer} from "../container/InscriptionContainer";
import {InscriptionAgenceAdmin} from "../pages/inscription/InscriptionAgenceAdmin";
import { FinalisationInscriptionAgenceAdmin } from '../pages/inscription/finalisationInscriptionAgenceAmin';
import {AgenceContainer} from "../container/AgenceContainer";


export const Routing = () => {
    return (
        <Routes>
            <Route
                index
                path="/"
                element={<Landing/>}
            />
            <Route path="/login" element={<Login/>}/>
            <Route exact path='/inscription/*' element={
                <InscriptionContainer>
                    <Routes>

                  <Route exact path='/choice' element={<InscriptionChoice />} />
                  <Route path="/particulier" element={<InscriptionParticulier />} />
                  <Route path="/agence-admin" element={<InscriptionAgenceAdmin />} />
              </Routes>
          </InscriptionContainer>
      } />
      <Route exact path='/*' element={
          <ProtectedRoute>
            <MainContainer>
              <Routes>
              <Route path="/map-mapbox" element={
                  <LandsMapByMapBox />
              }></Route>
              <Route path="/map" element={
                  <MapsContainer />
                }></Route>
                <Route path="/land" element={
                  <LandContainer />
                }></Route>
                <Route path="/my-land-map" element={
                  <MyLandMapsContainer />
                }></Route>
                  <Route path="/my-land" element={
                      <MyLandContainer />
                  }></Route>
                <Route path="/user" element={
                  <UserContainer />
                }></Route>
                  <Route path="/agence" element={
                      <AgenceContainer />
                  }></Route>
                <Route path="/tags" element={
                    <TagContainer />
                }></Route>
                <Route path="/transactions" element={
                    <TransactionContainer />
                }></Route>
                <Route path="/details/:id" element={
                  <DetailParcelle />
                } />
                <Route path="/list-crm" element={
                  <ListCrm />
                } />
                <Route path="/detail/:id/:contactId" element={
                    <ContactProvider>
                      <DetailCrm />
                    </ContactProvider>
                } />
                <Route path="/faos" element={
                    <FaosContainer />
                }></Route>
                <Route path="/account" element={<FinalisationInscriptionAgenceAdmin />} />
              </Routes>
            </MainContainer>
          </ProtectedRoute>
      } />
    </Routes>
  );
}
